import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card card-gray mt-3" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-3" }
const _hoisted_5 = { class: "mb-1 form-label" }
const _hoisted_6 = { class: "input-group" }
const _hoisted_7 = { class: "col-3" }
const _hoisted_8 = { class: "mb-1 form-label" }
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "col-5" }
const _hoisted_11 = { class: "mb-1 form-label" }
const _hoisted_12 = { class: "col-1 text-end align-content-end" }
const _hoisted_13 = ["title"]
const _hoisted_14 = {
  key: 0,
  class: "invalid-feedback d-block px-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.$t('accessLands.landNumber')), 1),
            _createElementVNode("div", _hoisted_6, [
              _withDirectives(_createElementVNode("input", {
                type: "number",
                min: "1",
                class: "form-control",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.prefixNumber) = $event))
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.prefixNumber,
                  void 0,
                  { number: true }
                ]
              ]),
              _cache[5] || (_cache[5] = _createElementVNode("div", { class: "px-3 py-2" }, "/", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "number",
                min: "1",
                class: "form-control",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.suffixNumber) = $event))
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.suffixNumber,
                  void 0,
                  { number: true }
                ]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t('accessLands.landType')), 1),
            _withDirectives(_createElementVNode("select", {
              class: "form-select",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.landType) = $event))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.landTypes, (landType) => {
                return (_openBlock(), _createElementBlock("option", { value: landType }, _toDisplayString(_ctx.$t('accessLands.landTypes.' + landType)), 9, _hoisted_9))
              }), 256))
            ], 512), [
              [_vModelSelect, _ctx.landType]
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t('accessLands.description')), 1),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.description) = $event))
            }, null, 512), [
              [_vModelText, _ctx.description]
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("button", {
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.removeLandAccess(_ctx.value))),
              class: "btn btn-outline-secondary mt-auto",
              title: _ctx.$t('form.buttonRemove')
            }, [...(_cache[6] || (_cache[6] = [
              _createElementVNode("span", { class: "fas fa-times" }, null, -1)
            ]))], 8, _hoisted_13)
          ])
        ])
      ]),
      (_ctx.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.error), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}